import Vue from "vue";
import colors from 'vuetify/lib/util/colors'

let themeColors = {
  primary: '#37CEBB',
  secondary: '#495057',
  accent: colors.red.darken3,
  danger: '#ea0606',

  lightGrey: '#AAAAAA',
  lightLightGrey: '#F5F5F5',
  darkGrey: '#495057',
  red: colors.red.darken3,
  lightGreen: '#E0F4F1'
};

export default themeColors;

export const theme = {
  install(Vue) {
    Vue.prototype.$theme = themeColors;
  }
};

Vue.use(theme);
